<template>
  <v-container fill-height fluid px-0 py-0 class="header-image">
    <v-layout fill-height>
      <v-flex xs12>
        <v-card class="elevation-6">
          <v-img class="white--text" height="200px" :src="mainImageUrl" />
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';

import store from '@/store/store';
import { SessionStorage } from '@/enums/sessionStorage.enum';
import { config } from '@/utils/config';

// @vuese
// Główna grafika
// @group MainLayout
export default {
  beforeCreate() {
    store.dispatch('settings/get', 'PUBLIC_MAIN_IMAGE').catch(err =>
      store.dispatch('notifyError', {
        title: 'Wystąpił błąd podczas pobierania ustawień.',
        messages: [err.message || err]
      })
    );
  },
  computed: mapState({
    mainImageUrl(state) {
      if (
        state.settings.PUBLIC_MAIN_IMAGE &&
        state.settings.PUBLIC_MAIN_IMAGE.value
      ) {
        return `${config.mediaURL}/${state.settings.PUBLIC_MAIN_IMAGE.value}`;
      }
      return '/img/main_image.jpg';
    }
  })
};
</script>

<style>
.header-image {
  margin-top: 60px;
}
</style>